import styled from 'styled-components';

const EBarNewsResultDiv = styled.div`
  width: 100%;
`;

EBarNewsResultDiv.displayName = 'EBarNewsResultDiv';

export default EBarNewsResultDiv;
